import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import DebtsReducer from "./Debts";
import InvoicesReducer from "./Invoices";
import localeReducer from "./Locale";
import PlanReducer from "./plan";
import DueReducer from "./Due";
import MoveDueReducer from "./MoveDue";
import LoginReducer from "./Login";
import UserReducer from "./User";
import PayNowReducer from "./Pay";
import WPReducer from "./WP";
import PaymentVerificationReducer from "./PaymentVerification";
import ErrorReducer from "./Error";
import JwksReducer from "./Jwks";
import OrderReducer from "./order"

import { LOGOUT } from "../actions/index";

const appReducer = combineReducers({
  login: LoginReducer,
  debts: DebtsReducer,
  invoices: InvoicesReducer,
  plan: PlanReducer,
  due: DueReducer,
  MoveDue: MoveDueReducer,
  payNow: PayNowReducer,
  locale: localeReducer,
  user: UserReducer,
  wordpress: WPReducer,
  paymentVerification: PaymentVerificationReducer,
  error: ErrorReducer,
  jwks: JwksReducer,
  router: routerReducer,
  order:OrderReducer
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    window.sessionStorage.clear();
    state = {};
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js